$(function () {
  //menu
  $(".menu").on("click", function () {
    if ($("#side_menu").hasClass("open")) {
      $("#side_menu").removeClass("open");
      $(".menu svg g").removeClass("icon-state-b");
      $("#side_menu .menu_container").prop({ scrollTop: 0 }, 0);
    } else {
      $("#side_menu").addClass("open");
      $(".menu svg g").addClass("icon-state-b");
    }
  });
  $("#side_menu").on("click touchend", function () {
    if (!$(event.target).closest(".menu_container").length) {
      $(".menu").click();
    }
  });

  // header search
  let beforePos = 0;
  var elemTop = $('.header_container').offset().top;
  $(window).on('scroll', function () {
    var scroll = $(window).scrollTop();
    if (scroll == beforePos) {
    } else if (beforePos < 50) {
      $(".header_search").removeClass('is_fixed');
      $(".header_search").addClass('is_show');
    } else if (elemTop > scroll || 0 > scroll - beforePos) {
      $(".header_search").addClass('is_show');
      if (!window.location.href.includes("/pages")) {
        $(".header_search").addClass('is_fixed');
      }
    } else {
      $(".header_search").removeClass('is_show');
      $(".header_search").removeClass('is_fixed');
    }
    beforePos = scroll;
  });

  $(".search").click(function () {
    $(".header_search").toggleClass('is_open');
  });
  $(".header_search").on("click", function () {
    if (!$(event.target).closest("form").length) {
      $(".header_search").removeClass('is_open');
    }
  });

  // news ticker
  const ticker = new Swiper('.header_ticker', {
    speed: 1000,
    loop: true,
    effect: 'slide',
    slidesPerView: 1,
    autoplay: {
      delay: 2000,
      reverseDirection: true,
      disableOnInteraction: false,
    },
    direction: 'vertical',
    wrapperClass: 'ticker_slide'
  });

  // top slide
  const hero = new Swiper('.hero', {
    speed: 800,
    loop: true,
    effect: 'slide',
    slidesPerView: 'auto',
    spaceBetween: 16,
    centeredSlides: true,
    roundLengths: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: true
    },
    lazy: {
      threshold: 50,
      observer: true,
      loadPrevNext: true,
      loadOnTransitionStart: true
    },
    wrapperClass: 'hero_slide',
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    breakpoints: {
      540: {
        spaceBetween: 30
      }
    }
  });

  //pickup slide
  var slidesCount = $('.collection_slide .swiper-slide').length;
  var pickup = new Swiper(".collection_slide", {
    loop: slidesCount > 4,
    speed: 600,
    slidesPerView: 2.3,
    spaceBetween: 15,
    slidesOffsetBefore: 15,
    slidesOffsetAfter: 20,
    watchOverflow: true,
    lazy: {
      threshold: 50,
      observer: true,
      loadPrevNext: true,
      loadOnTransitionStart: true
    },
    wrapperClass: 'collection_wrapper',
    observer: true,
    observeParents: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    effect: 'coverflow',
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 0,
      modifier: 1,
      slideShadows: false
    },
    breakpoints: {
      600: {
        slidesPerView: 2,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0
      },
      680: {
        slidesPerView: 3,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0
      },
      940: {
        slidesPerView: 4,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0
      },
      1200: {
        slidesPerView: 5,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0
      }
    },
    on: {
      beforeLoopFix: function () {
        $(".swiper-slide").removeClass("item");
      },
      afterInit: function (pickup) {
        pickup.autoplay.stop();
        const target = this.el;
        const options = {
          root: null,
          rootMargin: '-50% 0px',
          thredhold: 0
        };
        const observer = new IntersectionObserver(callback, options);
        observer.observe(target);
        function callback(entries) {
          entries.forEach(function (e) {
            let active = e.target.swiper;
            if (e.isIntersecting) {
              if (slidesCount > 4){
                active.autoplay.start();
              }
              $(".collection_wrapper").mouseenter(function (e) {
                active.autoplay.stop();
              }).mouseleave(function (e) {
                active.autoplay.start();
              });
            } else {
              active.autoplay.stop();
            }
          })
        }
      }
    }
  });

  // product slide
  const product = new Swiper('.product_main >.product_image', {
    speed: 1000,
    loop: true,
    effect: 'slide',
    slidesPerView: 1,
    lazy: true,
    wrapperClass: 'image_slide',
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    }
  });

  //favorite
  $(document).on("click touchend", "[class^='prime-review-favorites-product-']", function () {
    const variants = $(this).next("ul").children("li:first");
    toggleFavorite(variants);
});
  window.submitFavorite = async (url, handle, variant, save_for_later) => {
    const fetchOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        handle: handle,
        variant: variant,
        save_for_later: save_for_later,
        quantity: 1
      }),
    };
    await fetch(url, fetchOptions);
  }
  function toggleFavorite(source) {
    const variantId = $(source).attr("data-variant-id");
    const handle = $(source).attr("data-handle");
    const productHash = $(source).attr("data-product-hash");
    const heart = $(`.prime-review-favorites-heart-${productHash}`);
    const border = $(`.prime-review-favorites-heart-border-${productHash}`);
    var save_for_later = false;

    if (source.hasClass("exist")) {
      $(heart).removeClass(`prime-review-favorites-heart-${productHash}-enable`);
      $(heart).addClass(`prime-review-favorites-heart-${productHash}-disable`);
      $(border).removeClass(`prime-review-favorites-heart-border-${productHash}-enable`);
      $(border).addClass(`prime-review-favorites-heart-border-${productHash}-disable`);
      window.submitFavorite("/tools/prime-review/api/removeFavorite", handle, variantId, save_for_later);
    } else {
      $(heart).removeClass(`prime-review-favorites-heart-${productHash}-disable`);
      $(heart).addClass(`prime-review-favorites-heart-${productHash}-enable`);
      $(border).removeClass(`prime-review-favorites-heart-border-${productHash}-disable`);
      $(border).addClass(`prime-review-favorites-heart-border-${productHash}-enable`);
      window.submitFavorite("/tools/prime-review/api/addFavorite", handle, variantId, save_for_later);
    }
  }

  // shipping time
  var cut_off = koyomi.format(new Date(), 'H');
  var add_days = "0日"
  if (cut_off >= 14) {
    add_days = "1日";
  }
  var shipping_time = koyomi.add(koyomi.format(new Date(), 'Y-MM-DD'), $(".shipping_area select").val() + '日');
  $(".shipping_days").text(koyomi.format(koyomi.add(shipping_time, add_days), 'Y年M月D日（W>1）'));
  $(".shipping_area select").on("change", function () {
    shipping_time = koyomi.add(koyomi.format(new Date(), 'Y-MM-DD'), $(this).val() + '日');
    $(".shipping_days").text(koyomi.format(koyomi.add(shipping_time, add_days), 'Y年M月D日（W>1）'));
  });

  // series more
  if ($(".series_list >li").length > 3) {
    $(".collection_series .container").append('<p class="more_btn">全ての商品を見る</p>');
  };
  $(".collection_series .more_btn").on("click", function () {
    $(this).fadeOut();
    $(".series_list li").fadeIn();
  });

  // collection sort
  $("select[name=sort_by]").change(function () {
    if ($(this).val() != '') {
      window.location.href = $(this).val();
    }
  });

  // article table of contents
  var counter = 1;
  if (window.location.href.indexOf("column") > -1 || window.location.href.indexOf("blogs/zoskin") > -1) {
    if(document.querySelectorAll('.article_cont h2').length > 5){
      $("#article .article_cont .topics").append('<strong>目次</strong><input id="all_open" type="checkbox"><ul class="topics_list"></ul><label for="all_open">すべて表示</label>');
    }else{
      $("#article .article_cont .topics").append('<strong>目次</strong><ul class="topics_list"></ul>');
    }
    $("#article .article_cont h2").each(function () {
      var topic = "topic" + counter;
      $(this).attr("id", topic);
      var toctext = $(this).text();
      var element = "<li><a href='#" + topic + "'>" + toctext + "</a></li>";
      $(".topics_list").append(element);
      counter++;
    });
  }

  // anchor link
  $('a[href^="#"]').on("click", function (e) {
    e.preventDefault();
    var speed = 800;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var header_height = $(".header_container").height();
    var position = target.offset().top + 1 - header_height;
    $("html, body").animate({ scrollTop: position }, speed, "swing");
  });
  var urlHash = location.hash;
  if (urlHash) {
    $('body,html').stop().scrollTop(0);
    setTimeout(function () {
      var header_height = $(".header_container").height();
      var target = $(urlHash);
      var position = target.offset().top + 1 - header_height;
      $('body,html').stop().prop({ scrollTop: position }, 0);
    }, 100);
  }

  // login recover
  $('a[href="#recover"]').click(function () {
    $("#recover").toggleClass("open");
    return false;
  });
  $("#recover .close_btn").click(function () {
    $("#recover").removeClass("open");
    location.hash = '';
  });
  if ($("#recover .errors ul li").length) {
    var error_text = $("#recover .errors ul li").text();
    $('<div class="alert"><p>' + error_text + '</p></div>').appendTo("main");
  }
  if ($("#recover [role='status'] p").length) {
    $('<div class="alert"><p>メールを送信しました。</p></div>').appendTo("main");
  }
  // magazine check
  $("#marketing").click(function () {
    const willChangeVal = $("[name='customer[accepts_marketing]']").val() === "true" ? "false" : "true";
    $("[name='customer[accepts_marketing]']").val(willChangeVal);
  });
  // contact placeholder
  $("select#request-type").change(function () {
    if ($(this).children(':selected').text() == '商品の購入希望') {
      $('label[for="ContactFormMessage"] span').text("購入希望商品");
      $('label[for="ContactFormMessage"] small').text("購入希望の商品を教えてください。（複数商品ある場合は全て記載してください）");
      $("#ContactFormClinic").show();
    } else {
      $('label[for="ContactFormMessage"] span').text("メッセージ");
      $('label[for="ContactFormMessage"] small').text("ご相談内容を入力してください。");
      $("#ContactFormClinic").hide();
    }
  });

  $('.login-link').click(function (e) {
    if (!isWebViewOnMobileApp()) return;
    if (!window.appNavigation) return;

    e.preventDefault();
    var returnTo = window.location.pathname;
    window.appNavigation.postMessage(`push:/login?store_type=cfb&return_to=${returnTo}`);
  });

  $('.logout-link').click(function (e) {
    if (!isWebViewOnMobileApp()) return;
    if (!window.appNavigation) return;

    e.preventDefault();
    window.appNavigation.postMessage('logout');
  });
});

const isWebViewOnMobileApp = () => {
  var webviewParams = window.sessionStorage.getItem('WEB_VIEW_AUTH_PARAMS') || '';
  if (!webviewParams) return false;
  try {
    return !!JSON.parse(webviewParams)['isWebView']
  } catch {
    return false;
  }
}

const autoRedirectForMobileApp = (screen) => {
  if (!window.appNavigation) return;

  var returnTo = window.location.pathname;
  var url = new URL(window.location.href);
  var params = url.searchParams;

  var prevPathname = document.referrer ? new URL(document.referrer).pathname : '';

  // チェックアウトページからログアウトした場合、ホーム遷移
  // チェックアウトページからログアウトした事を明確に検知することはできないためこの条件で対応
  if (prevPathname === '/') {
    window.appNavigation.postMessage('logout');
    return;
  }

  // NOTE: 相対パスが入っている想定
  if (params.get('checkout_url')) {
    returnTo = encodeURIComponent(params.get('checkout_url'));
  }

  window.appNavigation.postMessage(`push:/${screen}?store_type=cfb&return_to=${returnTo}`);
}